<template>
    <div class="mono-icon" ref="monoIcon">
    <svg xmlns="http://www.w3.org/2000/svg"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      aria-labelledby="VolumeUpIcon"
      role="presentation"
      :fill="color"
    >
      <path d="M13.418 2.091A1 1 0 0 1 14 3v18a1 1 0 0 1-1.65.76L5.63 16H3a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2.63l6.72-5.76a1 1 0 0 1 1.068-.149zM12 5.175L6.65 9.76A1 1 0 0 1 6 10H4v4h2a1 1 0 0 1 .65.24L12 18.827V5.174zm5.293.119a1 1 0 0 1 1.414 0l.002.001.001.002.004.004.01.01a2.499 2.499 0 0 1 .114.125c.07.08.165.194.274.34.22.292.503.718.782 1.278C20.456 8.175 21 9.827 21 12s-.544 3.825-1.106 4.947c-.28.56-.562.986-.781 1.278a5.847 5.847 0 0 1-.389.465l-.01.01-.004.004-.001.002h-.001v.001a1 1 0 0 1-1.42-1.41l.005-.004.04-.045c.04-.045.102-.12.18-.223a6.39 6.39 0 0 0 .593-.972c.438-.878.894-2.226.894-4.053s-.456-3.175-.894-4.053a6.393 6.393 0 0 0-.594-.972 3.888 3.888 0 0 0-.22-.268l-.004-.005a1 1 0 0 1 .005-1.41zm-2 3a1 1 0 0 1 1.414 0l.002.001.001.002.003.003.008.008.02.02.055.061a4.697 4.697 0 0 1 .599.914c.31.623.605 1.525.605 2.698s-.294 2.075-.606 2.697c-.154.31-.312.548-.438.716a3.383 3.383 0 0 1-.215.26l-.02.02-.008.008-.003.003-.002.002a1 1 0 0 1-1.418-1.411 2.691 2.691 0 0 0 .315-.492c.19-.378.395-.976.395-1.803s-.206-1.425-.394-1.803a2.693 2.693 0 0 0-.316-.492 1 1 0 0 1 .002-1.412z"></path>
    </svg>
    </div>
</template>

<script>
export default {
  name: 'VolumeUpIcon',
  props: {
    size: {
        type: [String, Number],
        default: '24'
    },
    width: {
      type: [String, Number]
    },
    color: {
        type: String,
        default: 'currentColor'
    }
  }
}
</script>